<template>
  <modal
    name="monthly-subscription-form"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="470"
    :clickToClose="false"
    height="auto"
  >
    <div class="modalWrapper">
      <div class="row">
        <div class="col-12">
          <div class="content__box">
            <div class="content__box__header pb-2">
              <div class="top__filter align-items-center justify-content-center">
                <ul class="top__filter__ul">
                  <li>Monthly Subscription form</li>
                </ul>
              </div>
            </div>
            <div class="content__divider"></div>
            <div class="content__box__body py-0">
              <div class="monthlySubsForm">
                <div class="d-flex justify-content-center align-items-center mb-4" v-if="name!=''">
                  <p class="txt--ss txt--red mr-2 cursor-pointer" @click="deleteForm">
                    <i class="fas fa-trash"></i>
                  </p>
                  <a :href="name" target="_blank" class="txt--ss txt--semi-bold txt--off-white">
                    <span>{{name | truncate(15, '...')}}</span>pdf
                    <span class="ml-2">
                      <i class="fas fa-cloud-download-alt"></i>
                    </span>
                  </a>
                </div>
                <div class="monthlySubsForm__upload mb-1">
                  <label class="monthlySubsForm__upload__button">
                    <input type="file" accept="application/pdf" @change="uploadPdf"/>
                    Upload
                  </label>
                </div>
                <p class="txt--xs txt--off-white text-center">(Upload pdf only)</p>
                <!-- <p class="txt--ss txt--red text-center mt-4">PiedParker will charge {{monthly_application_fee_type == 'fixed' ? '$'+monthly_application_fee : monthly_application_fee+'%'}} for each monthly customer subscription.</p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: ["space_id","file_name","monthly_application_fee","monthly_application_fee_type"],
  data() {
    return {
      name : "",
      file : null ,
    };
  },
  created() {
    this.name = this.file_name ;
  },
  computed: {
    computeModalWidth() {
      if (this.$mq === "lg") return "900px";
      else return "400px";
    }
  },
  filters: {
    truncate: function(text, length, suffix) {
      let text_ar = text.split("/");
      text = text_ar[text_ar.length - 1];
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        let text_arr = text.split(".pdf");
        text = text_arr[0]+'.';
        return text;
      }
    }
  },
  methods: {
    closeModal() {
      this.$modal.hide("monthly-subscription-form");
      this.$emit("modal_closed");
    },
    uploadPdf(event)
    {
      if(event.target.files.length > 0 && event.target.files[0].type=="application/pdf")
      {
        if(event.target.files[0].size > 2097152)
        {
          this.$toasted.show("File size can not exceed 2MB",{
            icon : 'times-circle',
            className : 'error-class'
          });
          return ;
        }
        this.name = event.target.files[0].name ;
        this.file = event.target.files[0] ;
        this.formData = new FormData();
        this.formData.append("space_id", this.space_id);
        this.formData.append("customer_form", this.file);
        this.axios.post(window.hostname+'api/auth/upload-aggrement', this.formData,{
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(res=>{
          if(res.data.status)
          {
            this.name = res.data.data ;
            this.$toasted.show(res.data.message,{
              icon : 'check-circle',
              className :'success-class'
            });
            this.closeModal();
          }
          else
          {
            this.$toasted.show(res.data.message,{
              icon : 'times-circle',
              className : 'error-class'
            });
          }
        })
        .catch(err=>{
          console.log(err);
        });
      }
      else
      {
        this.$toasted.show("Please upload a proper pdf file!",{
          icon : 'times-circle',
          className : 'error-class'
        });
        return ;
      }
    },
    deleteForm()
    {
      const self = this ;
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to delete this form?",
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          self.axios.post(window.hostname+'api/auth/delete-aggrement',{
            space_id : self.space_id
          })
          .then(res=>{
            if(res.data.status)
            {
              self.name = "";
              self.file = null ;
              self.$toasted.show(res.data.message,{
                icon : "check-circle",
                className : 'success-class'
              });
            }
            else
            {
              self.$toasted.show(res.data.message,{
                icon : 'times-circle',
                className : 'error-class'
              });
            }
          })
          .catch(err=>{
            console.log(err);
          });
        }
      });
    }
  }
};
</script>

<style>
.vm--overlay {
  background: rgba(0, 0, 0, 0.9) !important;
}
</style>
